import { BaseRepository } from "./base-repository"
import { type IUserTenant } from "@/interfaces/api/user-tenant.interface"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"

export class UserTenantRepository extends BaseRepository<IUserTenant> {
  protected resourcePath = "auth/user-tenants"

  public async getUserTenants(): Promise<IUserTenant[]> {
    const response = await this.getList()
    return response.data
  }

  public async updateActiveTenant(tenantId: string): Promise<void> {
    await new HTTPRequestBuilder(HTTPMethods.POST, `${this.resourcePath}/update-active-tenant/`)
      .setData({ tenant_id: tenantId })
      .build()
      .execute()
  }
}
